import { VFC } from "react";

import ComingSoon from "components/ComingSoon";
import useLDFlag from "hooks/useLDFlag";

import CarrierIntegrationsFilterBarContainer from "./containers/CarrierIntegrationsFilterBarContainer";
import CarrierIntegrationsIndexContainer from "./containers/CarrierIntegrationsIndexContainer";

const CarrierIntegrationsPage: VFC = () => {
  const enableLtlAutoPricing = useLDFlag("enableLtlAutoPricing");

  if (!enableLtlAutoPricing) {
    return <ComingSoon />;
  }

  return (
    <>
      <CarrierIntegrationsFilterBarContainer />
      <div className="overflow-auto">
        <CarrierIntegrationsIndexContainer />
      </div>
    </>
  );
};

export default CarrierIntegrationsPage;
